












































































































































































import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
import _, { filter } from "lodash";
import numeral from "numeral";
import {
  SalesPackage,
  CartPackages,
  lacs,
  NullPackage
} from "@/interfaces/packages/sales_packages";
import DatePickerComponent from "@/components/controls/DatePickerComponent.vue";
import SimpleMessageDialog from "@/components/common/SimpleMessageDialog.vue";
import CartItemsTable from "@/components/conference/CartItemsTable.vue";
import { packagesList } from "@/services/api/cart";
import { setClientAuthentication } from "@/services/api/client";
import { AxiosInstance } from "axios";
import { loadMeetingState } from "@/services/api/meeting";
import { CartResponse } from "@/interfaces/meeting/details";
import { convertCart } from "@/utils/cart";
import { ALL, filterPackages } from "@/services/packages";
import GuidedCustom164 from "../packages/guidedCustom/GuidedCustom164.vue";
import { nonZeroNumberOnlyRules } from "@/forms/validation/numbers";
import { PackageBuiltEvent } from "../packages/guidedCustom/packageBuilt.interface";

@Component<CartDialog>({
  components: {
    DatePickerComponent,
    SimpleMessageDialog,
    CartItemsTable
  },
  data() {
    return {
      displayErrorDialog: this.showErrorDialog,
      error: this.errorTitle,
      errorDescription: this.errorDetails
    };
  }
})
export default class CartDialog extends Vue {
  @Prop({ required: true })
  showCart!: boolean;

  @Prop()
  addingToCart!: boolean;

  @Prop()
  selectedPackage!: SalesPackage;

  @Prop()
  packagesInCart!: CartPackages[];

  @Prop()
  submitDisabled!: boolean;

  @Prop({ default: "" })
  packageComment?: string;

  @Prop({ default: "" })
  additionalPackageField?: string;

  @Prop({ default: [] })
  dates!: string[];

  @Prop()
  minimumDate!: string;

  @Prop()
  showErrorDialog!: boolean;

  @Prop()
  errorTitle!: string;

  @Prop()
  errorDetails!: string;

  @Prop()
  removingPackage!: boolean;

  @Prop()
  itemClicked!: string;

  @Prop({ required: true })
  currency!: string;

  @Prop({ required: true })
  numberFormat!: string;

  @Prop({ default: "" })
  taxMessage!: string;

  @Prop({ default: 0 })
  eventId!: number;

  @Prop({ default: "" })
  additionalField!: string;

  @Prop({ default: false })
  isContract!: boolean;

  @Prop({ type: Number, default: -1 })
  selectedGiptPackageId!: number;

  apiClient!: AxiosInstance;
  packages: SalesPackage[] = [];
  packageCount!: number[];
  packageCountIncludingZero!: number[];
  loadingCart = false;
  loadingTable = false;
  displayErrorDialog = false;
  error!: string;
  errorDescription!: string;
  cities: string[] = [];
  selectedCity = ALL;
  selectedType = ALL;
  allPackages: SalesPackage[] = [];
  // since backend allows for multiple custom package
  previousCustomPackage = NullPackage;
  stations: string[] = [];

  created() {
    this.packageCount = _.range(1, 11);
    this.packageCountIncludingZero = _.range(0, 11);
    const token =
      new window.URLSearchParams(window.location.search).get("token") || "";
    this.apiClient = setClientAuthentication(token);
  }

  get nonZeroNumberOnlyRules() {
    return nonZeroNumberOnlyRules;
  }

  get guidedCustomComponent() {
    if (this.eventId === 164) {
      return GuidedCustom164;
    }
    return null;
  }

  get packageTypes() {
    const uniqueTypes = filterPackages(this.packages, {
      city: this.selectedCity,
      type: ALL
    })
      .reduce((aggregator, p) => {
        if (p.type && !aggregator.includes(p.type)) {
          aggregator.push(p.type);
        }
        return aggregator;
      }, [] as string[])
      .sort();
    if (uniqueTypes.length) {
      return [ALL, ...uniqueTypes];
    }
    return [];
  }

  onFilterByCity(city: string) {
    const types = this.packageTypes;
    if (!types.includes(this.selectedType)) this.selectedType = ALL;
  }

  onPackageBuild({ price, description }: PackageBuiltEvent) {
    this.selectedPackage.price = price;
    this.selectedPackage.description = description;
  }

  setCustomPackagePrice(inputPrice: string) {
    // type number v-text-field returns empty string when has alphabets
    // validation will trigger and let rep handle themselves
    if (inputPrice !== "") {
      this.selectedPackage.price = +inputPrice.replace(/[^\d.]/g, "");
    } else {
      this.selectedPackage.price = 0;
    }
  }

  resetCustomPackage() {
    if (this.isCustomPackage(this.selectedPackage)) {
      this.selectedPackage.price = 0;
      this.selectedPackage.description = "";
    }
  }

  resetPackages() {
    this.packages = this.allPackages;
    this.selectedCity = "";
    this.resetCustomPackage();
    this.stations = [];
    this.resetStations();
  }

  @Watch("selectedPackage")
  resetCustomPackageAfterUpdate() {
    if (this.previousCustomPackage.price) {
      // can't go by name since BE allows multiple custom package
      const customPackage = this.packages.find(
        _package => _package.id === this.previousCustomPackage.id
      );
      if (customPackage) {
        customPackage.price = 0;
        customPackage.description = "";
      }
    }
  }

  @Watch("showErrorDialog")
  handleError() {
    this.error = this.errorTitle;
    this.errorDescription = this.errorDetails;
    this.displayErrorDialog = this.showErrorDialog;
  }

  @Watch("showCart")
  async loadPackages() {
    if (this.showCart) {
      if (this.packagesInCart.length < 1) {
        try {
          this.loadingTable = true;
          // If sales rep exit meeting and rejoins, there may be some items in cart to load
          let { cart } = await loadMeetingState<CartResponse>(
            this.apiClient,
            "cart"
          );
          if (!cart) {
            cart = [];
          }
          const existingPackages = convertCart(cart);
          this.onFirstLoadCart(existingPackages);
        } catch (ex) {
          this.error = "Failed to load cart";
          this.errorDescription =
            "An unexpected error occurred while loading cart, please try again or contact an administrator if error persist.";
          this.displayErrorDialog = true;
        } finally {
          this.loadingTable = false;
        }
      }
      if (this.packages.length < 1) {
        this.loadingCart = true;
        try {
          const { packages } = await packagesList(this.apiClient);
          const cities = [] as string[];
          this.packages = packages.map(item => {
            // Note: Not the greatest idea to have side effects in a map, but trying to reduce loops
            if (item.cities && !cities.includes(item.cities))
              cities.push(item.cities);
            if (item.is_custom) {
              // Custom package comes in string "0"
              item.price.total = 0;
              item.description = "";
            }
            return {
              id: item.id,
              name: item.long_title,
              description: item.description,
              price: item.price.total,
              city: item.cities || "",
              type: item.package_type || "",
              isCustom: item.is_custom
            };
          });
          this.allPackages = Array.from(this.packages);
          if (cities.length > 1) {
            // Add "All" option in case user wants to remove filter
            cities.unshift(ALL);
            this.cities = cities.sort();
          }
        } catch (ex) {
          this.error = "Failed to load packages";
          this.errorDescription =
            "An unexpected error occurred while loading packages, please try again or contact an administrator if error persist.";
          this.displayErrorDialog = true;
        } finally {
          this.loadingCart = false;
        }
      }
      this.setSelectedGiptPackage();
    }
  }

  get isLacsFormat() {
    return lacs === this.numberFormat;
  }

  get packagesOptions() {
    return filterPackages(this.packages, {
      city: this.selectedCity,
      type: this.selectedType
    }).reduce((aggregator, salesPackage) => {
      if (!salesPackage.isCustom)
        return [
          ...aggregator,
          {
            text: `${salesPackage.name}, ${this.currency} ${this.currencyFormat(
              salesPackage.price
            )}`,
            value: salesPackage
          }
        ];
      let withCustom = [
        ...aggregator,
        {
          text: salesPackage.name,
          value: salesPackage
        }
      ];
      if (this.hasGuidedCustom) {
        withCustom = [
          ...withCustom,
          {
            text: "Calculator",
            // Need to make a copy so vuetify's "items" work and also we add a prop to identify. Typing to be reviewed
            value: { ...salesPackage, guided: true } as SalesPackage
          }
        ];
      }
      return withCustom;
    }, [] as { text: string; value: SalesPackage }[]);
  }

  get currencyFormat() {
    return (value: number) => {
      if (this.isLacsFormat) {
        return `${numeral(value / 100000).format("0.00")} ${lacs}`;
      }
      return numeral(value).format("0,0");
    };
  }

  get isCustomPackage() {
    return (value: SalesPackage) => {
      return value.isCustom;
    };
  }

  get hasGuidedCustom() {
    return [164].includes(this.eventId)
  }

  get isGuidedPackage() {
    return this.hasGuidedCustom && (this.selectedPackage as unknown as any).guided;
  }

  get customPackageValidated() {
    if (this.isCustomPackage(this.selectedPackage)) {
      return (
        !!this.selectedPackage.description && this.selectedPackage.price > 0
      );
    }
    return true;
  }

  setSelectedGiptPackage() {
    if (this.selectedGiptPackageId !== -1) {
      const selectedGiptPackage: SalesPackage | undefined = this.packages.find(
        _package => _package.id === this.selectedGiptPackageId
      );
      if (selectedGiptPackage !== undefined) {
        this.setPackage(selectedGiptPackage);
      }
    }
  }

  @Emit()
  hideErrorDialog() {
    this.displayErrorDialog = false;
    return;
  }

  @Emit()
  setPackage(value: SalesPackage) {
    this.resetCustomPackage();
    return value;
  }

  @Emit()
  setDates(value: string[]) {
    return value;
  }

  @Emit()
  updateDates(payload: { value: string; item: CartPackages }) {
    return payload;
  }

  @Emit()
  setPackageComment(value: string) {
    return value;
  }

  @Emit()
  setAdditionalPackageField(value: string) {
    return value;
  }

  @Emit()
  setStations(value: string) {
    return value;
  }

  @Emit()
  resetStations() {
    return;
  }

  @Emit()
  hideCart() {
    this.resetPackages();
    return;
  }

  @Emit()
  cancelCart() {
    this.resetPackages();
    return;
  }

  @Emit()
  async confirmCart() {
    return;
  }

  @Emit()
  async reserveCart() {
    return;
  }

  @Emit()
  onFirstLoadCart(existingPackages: CartPackages[]) {
    return existingPackages;
  }

  @Emit()
  updateCart() {
    if (this.isCustomPackage(this.selectedPackage)) {
      this.previousCustomPackage = this.selectedPackage;
      if (!this.isGuidedPackage) {
        this.selectedPackage.description = `Package inclusive of ${this.selectedPackage.description}`;
      }
    }
    this.stations = [];
    return;
  }

  @Emit()
  removePackage(item: CartPackages) {
    return item;
  }
}
